import { render } from "./banner.vue?vue&type=template&id=1573b576&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=1573b576&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1573b576"

export default script